import React from 'react';
import Signup from '../components/signup/Signup';
import Activation from '../components/signup/Activation';
import {connect} from 'react-redux';
import '../styles/signup-page.css';

const SignUpPage = ({needActivation}) => {
  console.log('needActivation', needActivation);
    return (
      <div>
        {
          !needActivation &&
            <Signup />
        }
        {
          needActivation &&
            <Activation />
        }

      </div>
  );
};

const SignUpPage1 = connect((state)=>{
  return {
    needActivation: state.authReducer.needActivation
  }
},//state
  null)(SignUpPage);

export default SignUpPage1;



// WEBPACK FOOTER //
// ./src/containers/SignUpPage.js